export const EXTRA_LARGE_VIEWPORT = 1600;
export const LARGE_VIEWPORT = 1200;
export const MEDIUM_VIEWPORT = 992;
export const SMALL_VIEWPORT = 768;
export const MOBILE_VIEWPORT = 576;
export const MOBILE_SMALL_VIEWPORT = 480;

export const fonts = {
  faFontsPath: '/css/webfonts',
  fontFamily: 'Raleway',
};

